import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      'Home Estimate': 'Home Estimate',
      'Cash Offers': 'Cash Offers',
      'Centris/MLS': 'Centris/MLS',
      'Buyer’s': 'Buyer’s',
      'About us': 'About us',
      'Partner’s': 'Partner’s',
      Reviews: 'Reviews'
    }
  },
  fr: {
    translation: {
      'Home Estimate': 'Home Estimate',
      'Cash Offers': 'Cash Offers',
      'Centris/MLS': 'Centris/MLS',
      'Buyer’s': 'Buyer’s',
      'About us': 'About us',
      'Partner’s': 'Partner’s',
      Reviews: 'Reviews'
    }
  }
}

const savedLanguage = localStorage.getItem('language')
const defaultLanguage = savedLanguage ? JSON.parse(savedLanguage).value : 'en'

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
})

export default i18n
